"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TitanAdKeyCtypeValues = exports.TitanAdKeyCat1Values = void 0;
var _listingType = _interopRequireDefault(require("./listing-type"));
var _listingUseType = _interopRequireDefault(require("./listing-use-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TitanAdKeyCatValues = {
  BUY: 'buy',
  RENT: 'rent',
  SHARE: 'share',
  SOLD: 'sold',
  FINDANAGENT: 'findanagent',
  NEWHOME: 'newhome',
  DOMAIN: 'domain'
};
var TitanAdKeyCat1Values = exports.TitanAdKeyCat1Values = {
  SEARCH_RESULTS: 'searchresults',
  MOVING: 'moving',
  DETAILS: 'details',
  BLOGS: 'blogs',
  DESIGN_AND_LIVING: 'designandliving',
  DIY: 'diy',
  GREEN: 'green',
  REAL_ESTATE_NEWS: 'realestatenews'
};
var TitanAdKeyCtypeValues = exports.TitanAdKeyCtypeValues = {
  HOMEPAGE: 'homepage',
  INDEX: 'index',
  ARTICLE: 'article',
  PHOTO_GALLERIES: 'photogalleries'
};
var TitanAdKey = {
  [_listingType.default.SALES_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: _listingUseType.default.RESIDENTIAL
  },
  [_listingType.default.RENTAL_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.RENT,
    cat2: _listingUseType.default.RESIDENTIAL
  },
  [_listingType.default.SHARE_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.SHARE,
    cat2: _listingUseType.default.RESIDENTIAL
  },
  [_listingType.default.SALES_COMMERCIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: _listingUseType.default.COMMERCIAL
  },
  [_listingType.default.RENTAL_COMMERCIAL.name]: {
    cat: TitanAdKeyCatValues.RENT,
    cat2: _listingUseType.default.COMMERCIAL
  },
  [_listingType.default.SALES_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: _listingUseType.default.RESIDENTIAL
  },
  [_listingType.default.SALES_BUSINESS.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: _listingUseType.default.BUSINESS
  },
  [_listingType.default.DEVELOPMENTS_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.NEWHOME,
    cat2: _listingUseType.default.RESIDENTIAL
  }
};
var _default = exports.default = TitanAdKey;